/**
 * SketchChair.js - Main Entry Point
 * Phase 1: Core Infrastructure Demo
 */

import { Application } from './core/Application.js';

// Loading screen shows for at least this long so the branded splash
// registers instead of flashing past on a fast load
const MIN_SPLASH_MS = 900;

/**
 * Fade out and remove the branded loading overlay (CSS transitions the
 * opacity via the .is-hidden class; we drop display afterwards).
 */
function hideLoadingScreen(startedAt) {
    const loading = document.getElementById('loading');
    if (!loading) return;
    const elapsed = Date.now() - startedAt;
    const wait = Math.max(0, MIN_SPLASH_MS - elapsed);
    setTimeout(() => {
        loading.classList.add('is-hidden');
        loading.addEventListener('transitionend', () => {
            loading.style.display = 'none';
        }, { once: true });
    }, wait);
}

// Initialize application when DOM is ready
async function init() {
    const startedAt = Date.now();
    try {
        console.log('SketchChair.js - Phase 1: Core Infrastructure');
        console.log('Initializing application...');

        // Create application instance
        const app = new Application();

        // Expose for debugging/console inspection
        window.sketchChairApp = app;

        // Initialize and start
        await app.init();
        app.start();

        // Fade out the branded loading screen
        hideLoadingScreen(startedAt);

        console.log('Application initialized successfully!');
    } catch (error) {
        console.error('Failed to initialize application:', error);

        // Show error in UI
        const loading = document.getElementById('loading');
        if (loading) {
            loading.innerHTML = `
                <div style="color: #f44336;">
                    <h2>Initialization Error</h2>
                    <p>${error.message}</p>
                </div>
            `;
        }
    }
}

// Start when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
